// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a859d501","239":"929699f9","453":"351e8c50","732":"7cbc02da"}[chunkId] + ".chunk.js";
};